<template>
  <div id="app">
    <div :class="classObj" class="app-wrapper">
      <sidebar v-if="!isBlank" class="sidebar-container" :menu-data="menuData" />
      <div class="main-container" :style="{marginLeft: isBlank ? '0' : '200px'}">
        <navbar v-if="!isBlank" />
        <section class="app-main">
          <breadcrumb v-if="!isBlank" :menu-data="menuData" class="breadcrumb-container" />
          <div id="app-main-content"></div>
        </section>
        <downloadDialog v-if="!isBlank" :visible.sync="downloadVisible" :handleDownloadStatus="handleDownloadStatus"></downloadDialog>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Navbar, Sidebar, Breadcrumb } from "./components";
// import ResizeMixin from './mixin/ResizeHandler';
import downloadDialog from './components/downloadDialog';

export default {
  name: "AppMain",
  components: {
    Navbar,
    Sidebar,
    Breadcrumb,
    downloadDialog,
  },
  props: {
    onGlobalStateChange: Function,
    setGlobalState: Function,
  },
  data() {
    return {
      downloadVisible: false,
    }
  },
  // mixin加屏幕断点，折叠左侧菜单
  // mixins: [ResizeMixin],
  computed: {
    ...mapState('user', {
      userInfo: state => state.userInfo,
      menuData: state => state.menuData,
    }),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
      }
    },
    isBlank() {
      return window.location.href.includes('cmtc_blank');
    }
  },
  methods: {
    ...mapActions('user', ['getUserInfo']),
    handleDownloadStatus(state) {
      this.setGlobalState({ downloadVisible: state })
    },
  },
  created() {},
  mounted() {
    const _this = this;
    this.onGlobalStateChange((newData) => {
      if (newData.downloadVisible !== null || newData.downloadVisible !== undefined) {
        _this.downloadVisible = newData.downloadVisible;
      }
    });
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/index.scss";
</style>

